import { render, staticRenderFns } from "./inboxHandler.vue?vue&type=template&id=947818c0&scoped=true"
import script from "./inboxHandler.vue?vue&type=script&lang=js"
export * from "./inboxHandler.vue?vue&type=script&lang=js"
import style0 from "./inboxHandler.vue?vue&type=style&index=0&id=947818c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947818c0",
  null
  
)

export default component.exports